import { BlockGroupBy } from './types';

export type BlockGroupByView = 'session' | 'cycle';

export type BlockGroupByState = {
  view: BlockGroupByView;
  all: boolean;
};

export const DEFAULT_BLOCK_GROUP_BY_STATE: BlockGroupByState = {
  view: 'session',
  all: false,
};

function isView(value: unknown): value is BlockGroupByView {
  return value === 'session' || value === 'cycle';
}

export function normalizeBlockGroupByState(value: unknown): BlockGroupByState {
  if (value && typeof value === 'object' && 'view' in value && 'all' in value) {
    if (isView(value.view) && typeof value.all === 'boolean') {
      return { view: value.view, all: value.all };
    }
  }
  return DEFAULT_BLOCK_GROUP_BY_STATE;
}

export function toggleGroupBy(
  current: BlockGroupByState,
  selected: BlockGroupBy,
): BlockGroupByState {
  if (selected === 'all') {
    return { view: current.view, all: true };
  }
  return { view: selected, all: false };
}

export function deriveGroupBy({
  state,
  hasWorkoutId,
}: {
  state: BlockGroupByState;
  hasWorkoutId: boolean;
}): BlockGroupBy {
  if (hasWorkoutId) return state.view;
  if (state.all) return 'all';
  return state.view;
}
